/**
 * @copyright Copyright MIDAS Eduction, LLC. (https://www.midaseducation.com/)
 */

import {defineMessages} from 'react-intl';
import StudentRouteLinkItem from './StudentRouteLinkItem';
import OtherContactsIcon from 'icons/OtherContactsIcon';

const messages = defineMessages({
  title: {id: 'navigation.other-contacts'},
});

const OtherContactsItem = () => (
  <StudentRouteLinkItem
    iconBefore={OtherContactsIcon}
    route="midas/student/other-contacts"
    title={messages.title}
  />
);

export default OtherContactsItem;
